module.exports = __webpack_public_path__ + "img/default-label.373164a6.svg";